const INVALID_FIELD_SELECTOR = [
  '.fg-field-inner.has-error',
  '.file-list-invalid',
  '.flow-table-runner .error-list'
].join(', ');
const FOCUSABLE_FIELD_SELECTOR = [
  'button:not([disabled])',
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  'a[href]',
  '[contenteditable="true"]',
  '[tabindex]:not([tabindex="-1"]):not([disabled]):not(:disabled):not([aria-disabled="true"])'
].join(', ');

export type UseScrollToFieldHandler = (root?: ParentNode) => HTMLElement | null;

// find the first invalid field within the specified root and scroll to it, focusing its first focusable child if available
export const useScrollToField: UseScrollToFieldHandler = (
  root?: ParentNode
): HTMLElement | null => {
  const searchRoot: ParentNode | null =
    root ?? (typeof document === 'undefined' ? null : document);

  if (!searchRoot) {
    return null;
  }

  const invalidFieldMarker = searchRoot.querySelector<HTMLElement>(
    INVALID_FIELD_SELECTOR
  );

  if (!invalidFieldMarker) {
    return null;
  }

  const invalidField =
    invalidFieldMarker.closest<HTMLElement>('.fg-field-inner') ??
    invalidFieldMarker;
  const focusableField = invalidField.querySelector<HTMLElement>(
    FOCUSABLE_FIELD_SELECTOR
  );
  focusableField?.focus({ preventScroll: true });
  invalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });

  return invalidField;
};
